<div class="{{ itemAlignmentClasses }}">
  @for (item of dragDataValue; track item; let i = $index) {
    <div class="external-drag-drop-item hover:bg-gray-100 dark:hover:bg-gray-850"
      dndDraggable
      [dndDraggable]="item.data"
      [dndEffectAllowed]="'copy'"
      [dndDisableIf]="false"
      (dndStart)="onDragStart($event)"
      (dndEnd)="onDragEnd($event)">
      <ng-container *ngTemplateOutlet="templateOutlet; context: {$implicit: item.data}"></ng-container>
      <ng-content></ng-content>
    </div>
  }
</div>
